import { createApp } from 'vue';
/*轻量、可靠的移动端 Vue 组件库*/ 
import vant from 'vant';
import { Toast } from 'vant';
import { Loading } from 'vant';
import 'vant/lib/index.css';
import { store } from './store'
import { router } from './router'
import App from './App.vue'
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

const app = createApp(App)
app.component('remote-script', {
    render: (createElement) => <script src={createElement.src}></script>,
    props: {
        src: {
            type: String,
            required: true
        }
    }
})
app.use(store).use(router).use(vant).use(Toast).use(Loading).use(VueVideoPlayer).mount('#app')
